<template>

  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" data-name="Layer 1" viewBox="0 0 160 600" :height="t_output_height" :width="t_output_width">
    <rect fill="#46196e" width="100%" height="100%" />
    <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPIAAAA0CAYAAACw2WUNAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAuUlEQVR4Xu3ToRGEAADEwOMF/bcL6kvAQmZXx+bYdm07B3zV/XsqgPczMgQYGQKMDAFGhgAjQ4CRIcDIEGBkCDAyBBgZAowMAUaGACNDgJEhwMgQYGQIMDIEGBkCjAwBRoYAI0OAkSHAyBBgZAgwMgQYGQKMDAFGhgAjQ4CRIcDIEGBkCDAyBBgZAowMAUaGACNDgJEhwMgQYGQIMDIEGBkCjAwBRoYAI0OAkSHAyBBgZAgwMgQYGQL+aZsCYVH6fv4AAAAASUVORK5CYII=" width="242" height="52" data-name="CTA box Image" transform="matrix(.5 0 0 .5 19.5 497.5)"/>
    <path d="M19.4028 497.7084h121v26h-121z" data-name="cta"/>
    <text fill="#fff" font-family="Tele-Grotesk Next-Ultra" font-size="16" font-weight="800" transform="translate(45.3344 516.1657)">Enter Here</text>
    <text  y="45" width="83"   text-anchor="middle" font-family="Tele-Grotesk Next-Ultra" font-size="18" font-weight="800" letter-spacing="-.02em" fill="#fff">
      <tspan dy="1em" x="50%" v-for="(word) in verticalStacked" :key="word.id">
        {{ word.word }}

      </tspan>
    </text>
    <text
      text-anchor="middle" data-name="LEGAL" transform="translate(0 535)"
      style="font-size:7.5px;fill:#fff;font-family:TT-Norms Medium"
    >
      <tspan  x="50%" dy="1em" v-for="(line) in templateLegalArr" :key="line.id">
        {{ line }}
      </tspan>
    </text>
    <path fill="#fff" d="M16.5367 31.6404v1.48h2.6035v1.3121h-2.6035v1.5957h2.7085v1.3125h-4.1257v-7.0128h4.126v1.3125ZM25.9176 30.3279v7.0127h-1.4381l-2.5093-4.3882h-.063v4.3882h-1.417v-7.0127h1.438l2.52 4.4091h.063v-4.4091ZM26.7657 30.3279h5.0078v1.3125h-1.7949v5.7h-1.4175v-5.7h-1.7954ZM34.0387 31.6404v1.48h2.6035v1.3121h-2.6035v1.5957h2.7085v1.3125h-4.126v-7.0128h4.126v1.3125ZM41.4141 37.3406l-1.3222-2.5616h-.6824v2.5616h-1.417v-7.0127h2.5927a2.1284 2.1284 0 0 1 2.3304 2.2259 2.0439 2.0439 0 0 1-1.4067 2.0787l1.48 2.7085Zm-2.0046-3.8843h1.1128a.9081.9081 0 1 0 0-1.8159h-1.1128ZM47.3155 31.6404v1.5849h2.5088v1.3125h-2.5088v2.8028h-1.417v-7.0127h4.02v1.3125ZM50.6676 33.8338c0-2.2676 1.05-3.6743 2.9712-3.6743s2.9707 1.4071 2.9707 3.6743-1.05 3.6743-2.9707 3.6743-2.9712-1.4063-2.9712-3.6743Zm4.4721 0c0-1.5327-.5249-2.31-1.5009-2.31s-1.5015.7769-1.5015 2.31.5249 2.31 1.5015 2.31 1.5007-.7769 1.5007-2.31ZM61.1329 37.3406l-1.3223-2.5616h-.6826v2.5616h-1.417v-7.0127h2.5928a2.1284 2.1284 0 0 1 2.3306 2.2259 2.044 2.044 0 0 1-1.4068 2.0787l1.48 2.7085Zm-2.0049-3.8843h1.1128a.9081.9081 0 1 0 0-1.8159H59.128ZM69.3126 35.9758h-2.4253l-.4517 1.3648h-1.438l2.3936-7.0127h1.4175l2.3935 7.0127h-1.4384Zm-.4307-1.312-.7558-2.2783h-.063l-.7456 2.2783ZM76.5255 30.1599a2.6074 2.6074 0 0 1 2.667 2.3939H77.712a1.17 1.17 0 0 0-1.1865-1.0288c-.9658 0-1.501.7979-1.501 2.31s.5352 2.31 1.501 2.31a1.17 1.17 0 0 0 1.1865-1.0288h1.4805a2.6074 2.6074 0 0 1-2.667 2.3935c-1.9 0-2.9707-1.417-2.9707-3.6743s1.0708-3.6755 2.9707-3.6755ZM85.5195 30.3279v7.0127h-1.417v-2.9082h-2.51v2.9082h-1.417v-7.0127h1.417v2.7924h2.51v-2.7924ZM90.6231 35.9758h-2.4248l-.4511 1.3648h-1.4385l2.3935-7.0127h1.4173l2.3936 7.0127h-1.4378Zm-.4306-1.312-.7559-2.2783h-.0625l-.7446 2.2783ZM98.7306 30.3279v7.0127h-1.4385l-2.5088-4.3882h-.0638v4.3882h-1.417v-7.0127h1.4385l2.5195 4.4091h.0625v-4.4091ZM102.8028 30.1599a2.607 2.607 0 0 1 2.6667 2.3939h-1.48a1.17 1.17 0 0 0-1.1865-1.0288c-.9658 0-1.501.7979-1.501 2.31s.5352 2.31 1.501 2.31a1.17 1.17 0 0 0 1.1865-1.0288h1.48a2.607 2.607 0 0 1-2.667 2.3935c-1.8994 0-2.9707-1.417-2.9707-3.6743s1.0716-3.6755 2.971-3.6755ZM107.8702 31.6404v1.48h2.6035v1.3121h-2.6035v1.5957h2.708v1.3125h-4.126v-7.0128h4.126v1.3125ZM113.1622 30.3279h5.0078v1.3125h-1.7949v5.7h-1.417v-5.7h-1.7959ZM118.6886 33.8338c0-2.2676 1.05-3.6743 2.9707-3.6743s2.9707 1.4067 2.9707 3.6743-1.0489 3.6743-2.9707 3.6743-2.9707-1.4063-2.9707-3.6743Zm4.4726 0c0-1.5327-.5254-2.31-1.5019-2.31s-1.501.7769-1.501 2.31.5244 2.31 1.501 2.31 1.5019-.7769 1.5019-2.31ZM136.1905 30.3279l-1.8584 7.0127h-1.5326l-1.166-4.7452h-.0625l-1.166 4.7452h-1.5215l-1.8692-7.0127h1.459l1.1446 4.8183h.0634l1.1338-4.8183h1.585l1.1338 4.8183h.0625l1.1347-4.8183ZM137.0059 30.3279h1.417v7.0127h-1.417ZM145.21 30.3279v7.0127h-1.4384l-2.5088-4.3882h-.0625v4.3882h-1.418v-7.0127h1.4385l2.5195 4.4091h.0635v-4.4091Z"/>
    <image x="0" y="204" width="160" height="224" :href="selectedImage"></image>
    <image x="22" y="451" width="115" height="40" href="@/assets/metro-logo-tight--white.png"></image>
  </svg>
</template>

<script>
export default {
  name: 'METROSP160x600',
  props: {
    selectedImage: {
      type: String,
      default: ''
    },
    templateAbbrPrizeDescription: {
      type: String,
      default: ''
    },
    templateAbbrLegal: {
      type: String,
      default: ''
    },
    t_output_height: {
      type: [Number, String],
      default: 600
    },
    t_output_width: {
      type: [Number, String],
      default: 160
    },
    templateLegalArr: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    verticalStacked() {
      return this.templateAbbrPrizeDescription.split(' ').map((word, index) => {
        return {
          word: word,
          y: index * 66.87
        };
      });
    }
  }
};
</script>